import { plural } from '@lingui/macro';

const getSamplesAndPacksByline = ({
    sampleCount,
    packCount,
    separator,
}: {
    sampleCount?: number;
    packCount?: number;
    separator: string;
}): string => {
    const pack = packCount
        ? plural(packCount, {
              one: '# pack',
              other: '# packs',
          })
        : '';

    const sample = sampleCount
        ? plural(sampleCount, {
              one: '# sample',
              other: '# samples',
          })
        : '';

    const hasPackAndSamples = !!pack && !!sample;
    const conditionalSeparator = hasPackAndSamples ? separator : '';

    const packsAndSamples = `${pack}${conditionalSeparator}${sample}`;

    return packsAndSamples;
};

export default getSamplesAndPacksByline;
